/**
 * Created by claudio iozzia on 03/07/2017.
 */
import {Validator_Common} from "../../../../models/validator/validator_common";
import {Ic, IEntityAlert} from "../../../../models/common";
import {Utils} from "../../../../common/utils";
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import * as R from "ramda";


// tslint:disable-next-line:class-name
export class Validator_DcDc_LLC extends Validator_Common {

  private validatorFn_SingleOutput_Voltage_LLC: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const result = Utils.acceptInRange(_vOut, a.vout_min, a.vout_max, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_LLC: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _iOut = spec.spec.value.output.outputs[o].current;
    const result = Utils.acceptInRange(_iOut,  R.propOr(0, 'iout_min',  a) , a.iout_max, "Iout", "A");
    return new EntityError(result);
  }

  protected validatorFn_SingleOutput_Pout_LLC: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert  => {
    const i_min = R.propOr(0, 'iout_min',  a);
    const p_max = R.propOr(a.vout_max * a.iout_max, 'pout_max',  a);
    const p_min = R.propOr(a.vout_min * i_min, 'pout_min',  a);
    const output = spec.spec.value.output.outputs[o];
    const result = Utils.acceptInRange(output.power,  p_min, p_max, "Pout", "W");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_LLC].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_LLC].concat(super.singleOutputI());
  }

  protected singleOutputP(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Pout_LLC].concat(super.singleOutputP());
  }
}
